import React from 'react';
import { createPortal } from 'react-dom';
import './Genwizui.css';
import { useState } from 'react';

let genUIState = {}


function Gwloading(config) {
  const uiwidth = config.width || 360;
  const uiheight = config.height || 160;
  const uitext = config.text || "Loading";
  const timeOut = config.timeOut || 'infinite';
  const visible = config.visible || true;
  const uistyle = {
    width: `${uiwidth}px`,
    height: `${uiheight}px`
  };

  if (visible === false) {
    return (
      <></>
    )
  }

  if (timeOut === 'infinite') {
    return (
      <div className='gw-ui'>
        <div className='gw-loading' style={uistyle}>
          <div className="gw-title">{uitext}</div>
          <div className="gw-body">
            <div className='gw-loader'></div>
          </div>
        </div>
      </div>
    );
  } else {
    setTimeout(() => {
      config.stateFunction({});
    }, timeOut)
    return (
      <div className='gw-ui'>
        <div className='gw-loading' style={uistyle}>
          <div className="gw-title">{uitext}</div>
          <div className="gw-body">
            <div className='gw-loader'></div>
          </div>
        </div>
      </div>
    )
  }
};

//Views
function GwDisplay(config) {
  const uiwidth = config.width || '800px';
  const uiheight = config.height || '600px';
  const uitext = config.text || "";
  const CustomElem = config.customElement || <></>;
  const uistyle = {
    width: `${uiwidth}`,
    height: `${uiheight}`
  };

  return (
    <div className='gw-ui'>
      <div className='gw-box' style={uistyle}>
        <div className="gw-title">{uitext}
          <span style={{ float: 'right', padding: '5px', margin: '-5px 5px 0 5px', cursor: 'pointer' }} onClick={() => { genUIState = {}; config.stateFunction({}) }}>
            &#10006;
          </span>
        </div>
        <div className="gw-body">
          {CustomElem}
        </div>
      </div>
    </div>
  )
};

// input
function GwInput(config) {
  const uiwidth = config.width || '360px';
  const uiheight = config.height || '160px';
  const uitext = config.text || "Loading";
  const pattern = config.pattern || "";
  const inpUse = config.type || "text";
  const uistyle = {
    width: `${uiwidth}`,
    height: `${uiheight}`
  };

  const submitClick = () => {
    const inpField = document.getElementById('gwInputField');
    config.bntSubmit(inpField.value);
    if (!config.onloop || config.onloop === undefined) {
      config.stateFunction({})
    }
  }

  const inpType = (() => {
    let inpCompo = null

    switch (inpUse) {
      case 'select': inpCompo = <>
        <select id="gwInputField">
          <option value=""></option>
          <option value=""></option>
          <option value=""></option>
          <option value=""></option>
          <option value=""></option>
        </select>
      </>;
        break;

      case 'textarea': inpCompo = <textarea id="gwInputField" style={{ width: '90%', padding: '5px', height: '80px', resize: 'none' }}></textarea>
        break;

      default: inpCompo = <input type={inpUse} id="gwInputField" placeholder="Type here" style={{ textAlign: 'center' }} />;
        break;
    }

    return <>{inpCompo}</>;
  })();

  return (
    <div className='gw-ui'>
      <div className='gw-box' style={uistyle}>
        <div className="gw-title">{uitext}</div>
        <div className="gw-body">
          <br />
          {inpType}
          <br />
          <input type="button" value="Submit" onClick={() => submitClick()} />
          <input type="button" value="Cancel" onClick={() => config.stateFunction({})} />
        </div>
      </div>
    </div>
  )
};

// confirm
function GwAlert(config) {
  const uiwidth = config.width || 360;
  const uiheight = config.height || 160;
  const uitext = config.text || "Loading";
  const cbfunc = config.callback;
  const uistyle = {
    width: `${uiwidth}px`,
    height: `${uiheight}px`
  };

  const okClick = () => {
    if (genUIState) {
      config.stateFunction(genUIState)
    } else {
      config.stateFunction({})
    }

    if (cbfunc !== undefined) {
      cbfunc();
    }
  }

  return (
    <div className='gw-ui'>
      <div className='gw-box' style={uistyle}>
        <div className="gw-title">Info</div>
        <div className="gw-body">
          <br />
          <span>{uitext}</span>
          <br /><br />
          <input type="button" value="Ok" onClick={() => okClick()} style={{ float: 'right' }} />
        </div>
      </div>
    </div>
  )
};

// confirm
function GwConfirm(config) {
  const uiwidth = config.width || 360;
  const uiheight = config.height || 160;
  const uitext = config.text || "Loading";
  const uistyle = {
    width: `${uiwidth}px`,
    height: `${uiheight}px`
  };

  const noClick = () => {
    if (genUIState) {
      config.stateFunction(genUIState)
    } else {
      config.stateFunction({})
    }
  }

  const yesClick = () => {
    genUIState = {}
    config.bntYes(true);
    if (!config.onloop || config.onloop === undefined) {
      config.stateFunction({})
    }
  }

  return (
    <div className='gw-ui'>
      <div className='gw-box' style={uistyle}>
        <div className="gw-title">Warning</div>
        <div className="gw-body">
          <br />
          <span>{uitext}</span>
          <br /><br />
          <input type="button" value="Yes" onClick={() => yesClick()} />
          <input type="button" value="No" onClick={() => noClick()} />
        </div>
      </div>
    </div>
  )
};

export default function GenWiz({ open, appconfig }) {

  const appName = appconfig.appName || '';
  const cbhis = appconfig.cbhistory || false;
  let params = appconfig.config || {}

  if (!open) return null;
  if (appName === '') return null;

  if (appName !== '' && params === undefined) {
    console.error('GenwizUi needs a appconfig');
  }

  if (cbhis) {
    genUIState = appconfig
    params = { ...params, cbhistory: true }
  }

  const genWizApp = {
    'gwLoading': Gwloading(params),
    'gwDisplay': GwDisplay(params),
    'gwAlert': GwAlert(params),
    'gwInput': GwInput(params),
    'gwConfirm': GwConfirm(params)
  }

  const GenwizCompnent = genWizApp[appName]

  return createPortal(<>{GenwizCompnent}</>, document.body)
};